import styled from "styled-components";
import CustomGraphModel from "./model";

const CustomGraph = styled(CustomGraphModel)`
  #root && {
    
  }
`;
export {CustomGraph}